var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"image-upload",attrs:{"for":"file-input"}},[_vm._t("default",function(){return [_c('ImageIcon')]}),_c('input',{ref:"input",attrs:{"id":"file-input","type":"file","accept":"image/*"},on:{"change":_vm.change}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }